// צור קובץ חדש: src/config/fundNamesConfig.js

/**
 * 🏷️ קונפיגורציית שמות מותאמים לקרנות
 */

// מיפוי שמות מותאמים לפי FUND_ID
export const CUSTOM_FUND_NAMES = {
    // קרנות השתלמות
    '962': 'אנליסט השתלמות - כללי',
    '14394':' מור - עוקב מדדים גמיש',
    '14342':' מור גמל - משולב סחיר',  
'12534':'מור גמל לבני 60 ומעלה',
'12533':'מור גמל לבני 50 -60',
'12532':'מור גמל לבני 50 ומטה',
'12531':'מור גמל מניות',
'9452':'מור גמל sp500',
    // הוסף עוד קרנות כאן...
};

// כללי עיבוד שמות אוטומטיים
export const NAME_PROCESSING_RULES = {
    // הסרת מילים מיותרות
    removeWords: [
        // ביטויים ארוכים קודם
        'קרן השתלמות לשכירים ולעצמאים',
        'קופת גמל לתגמולים ופיצויים',
        'קופת גמל להשקעה',
        'חברה לביטוח בע"מ',
        'לשכירים ולעצמאים',
        'עובדים ועצמאים',
        'תגמולים ופיצויים',
        'קרן השתלמות',
        'קופת גמל',
        'חברה לביטוח',
        'בע"מ',
        'מ.ב.',
        'מ.ב',
        'בע״מ',
        'ח.ל.ב',
        'מסלולית',
        '- כללי',
        'כללי',
        'מסלול כללי',
        
        // הוספת כללי חדשים עבור אלפא מור
        'לתגמולים',
        'אישית לפיצויים'
    ],

    // החלפת מילים
    replacePatterns: [
        // החלפות ספציפיות
        { from: /מסלולית/gi, to: '' },
        { from: 'קרן השתלמות לשכירים ולעצמאים', to: 'השתלמות' },
        { from: 'קופת גמל לתגמולים ופיצויים', to: 'גמל' },
        { from: 'קופת גמל להשקעה', to: 'גמל השקעה' },
        { from: 'גמל להשקעה', to: 'גמל השקעה' },
        { from: 'קרן השתלמות', to: 'השתלמות' },
        { from: 'קופת גמל', to: 'גמל' },
        { from: 'אלפא מור', to: 'מור' },
        
        // כלל מיוחד לאלפא מור - משיכת החלקים החשובים בלבד
        // חשוב: הכללים הספציפיים קודם, הכלל הכללי אחרון!
        
        // אם יש עוקב מדד S&P 500
      
        // ניקוי מיותר
        { from: /\s*-\s*מסלול\s*/gi, to: ' - ' },
        { from: /\s*מסלול\s*/gi, to: ' ' },
    ],

    // קיצורים לחברות
    companyShortcuts: {
        'מנורה מבטחים': 'מנורה',
        'הפניקס ישראל': 'הפניקס',
        'מגדל חברה לביטוח': 'מגדל',
        'כלל ביטוח': 'כלל',
        'הראל ביטוח': 'הראל'
    },

    // 🧹 ניקוי סופי
    finalCleanup: [
        { from: /\s*-\s*$/, to: '' }, // הסרת מקף בסוף
        { from: /^\s*-\s*/, to: '' }, // הסרת מקף בהתחלה
        { from: /\s{2,}/g, to: ' ' }, // החלפת רווחים כפולים ברווח יחיד
        { from: /\s*-\s*/g, to: ' - ' }, // תיקון מקפים
    ]
};

/**
 * 🎨 פונקציה מתקדמת לעיבוד שמות אוטומטי
 */
// הוסף זאת לתחילת הפונקציה processAutomaticName, לפני כל הכללים:

export function processAutomaticName(originalName, fundId) {
    // בדיקה אם יש שם מותאם ידנית
    if (CUSTOM_FUND_NAMES[fundId?.toString()]) {
        return CUSTOM_FUND_NAMES[fundId?.toString()];
    }
    
    if (!originalName) return 'לא ידוע';
    
    let processedName = originalName.trim();
    
    // 🛡️ שלב 0: הגנה על ביטויים חשובים - החלפה בטוקנים זמניים
    const protectedPhrases = {
        'PROTECTED_INDEX_STOCKS': /עוקב מדדי מניות/gi,
        'PROTECTED_INDEX_BONDS': /עוקב מדדי אגח/gi,
        'PROTECTED_INDEX_TRACKING': /עוקב מדדים/gi,
        'PROTECTED_SP500': /S&P 500/gi,
        'PROTECTED_TRADABLE_STOCKS': /מניות סחיר/gi,
        'PROTECTED_TRADABLE_MIXED': /משולב סחיר/gi,
        'PROTECTED_GOVERNMENT_BONDS': /אגח ממשלתיות/gi,
        'PROTECTED_CREDIT_BONDS': /אשראי ואגח/gi,
        'PROTECTED_AGE_50_UNDER': /עד גיל 50/gi,
        'PROTECTED_AGE_50_60': /גיל 50 עד 60/gi,
        'PROTECTED_AGE_50_60_SHORT': /50-60/gi,
        'PROTECTED_AGE_60_OVER': /מעל גיל 60/gi,
        'PROTECTED_AGE_60_PLUS': /60 ומעלה/gi,
        'PROTECTED_AGE_50_UNDER_BENI': /בני 50 ומטה/gi,
        'PROTECTED_AGE_60_PLUS_BENI': /בני 60 ומעלה/gi
    };
    
    // החלף ביטויים מוגנים בטוקנים
    Object.entries(protectedPhrases).forEach(([token, regex]) => {
        processedName = processedName.replace(regex, token);
    });
    
    // שלב 1: החלפת ביטויים ארוכים קודם
    NAME_PROCESSING_RULES.replacePatterns.forEach(pattern => {
        if (pattern.from instanceof RegExp) {
            processedName = processedName.replace(pattern.from, pattern.to);
        } else {
            const regex = new RegExp(pattern.from.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
            processedName = processedName.replace(regex, pattern.to);
        }
    });
    
    // שלב 2: קיצור שמות חברות
    Object.entries(NAME_PROCESSING_RULES.companyShortcuts).forEach(([full, short]) => {
        if (processedName.includes(full)) {
            processedName = processedName.replace(full, short);
        }
    });
    
    // שלב 3: הסרת מילים מיותרות (אחרי החלפות)
    NAME_PROCESSING_RULES.removeWords.forEach(word => {
        const regex = new RegExp(`\\b${word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'gi');
        processedName = processedName.replace(regex, '').trim();
    });
    
    // שלב 4: ניקוי סופי
    NAME_PROCESSING_RULES.finalCleanup.forEach(cleanup => {
        processedName = processedName.replace(cleanup.from, cleanup.to);
    });
    
    // 🔄 שלב סופי: החזרת הביטויים המוגנים
    Object.entries(protectedPhrases).forEach(([token, regex]) => {
        const originalPhrase = originalName.match(regex)?.[0];
        if (originalPhrase) {
            processedName = processedName.replace(new RegExp(token, 'gi'), originalPhrase);
        }
    });
    
    // וידוא שהשם לא ריק
    processedName = processedName.trim();
    if (!processedName || processedName.length < 2) {
        return originalName;
    }
    
    return processedName;
}

/**
 * 🏷️ פונקציה פשוטה לקבלת שם מותאם
 */
export function getDisplayName(product) {
    const fundId = product.id?.toString();
    
    // קודם בדוק שם מותאם ידנית
    if (CUSTOM_FUND_NAMES[fundId]) {
        return CUSTOM_FUND_NAMES[fundId];
    }
    
    // אחרת השתמש בעיבוד אוטומטי
    return processAutomaticName(product.name, fundId);
}

// ייצוא פונקציות נפרדות לצרכים מיוחדים
export function addCustomName(fundId, customName) {
    CUSTOM_FUND_NAMES[fundId.toString()] = customName;
   
}

export function removeCustomName(fundId) {
    delete CUSTOM_FUND_NAMES[fundId.toString()];
    
}

export function getAllCustomNames() {
    return { ...CUSTOM_FUND_NAMES };
}